import React, { useState, useEffect, useRef } from "react";
import GridTable from "@nadavshaar/react-grid-table";
import setColumns from "./setColumns.js";
import Modalv2 from "../../components/tables/Modalv2";
import ValidView from "../../components/app/validView";
import Spinner from 'react-bootstrap/Spinner';
import ModalMultiOrders from './ModalMultiOrders';
import ModalExportExcel from "../../components/tables/ModalExportExcel";
import CustomHeader from "../../components/tables/CustomHeader";
import { searchUtils } from "../../components/tables/searchUtils";

const Orders = ({ defaultFilter }) => {
  const rowsPerPageString = process.env.REACT_APP_GRID_ROWSPERPAGE;
  const rowsPerPageArray = rowsPerPageString.split(',').map(Number);

  const objFilterRef = useRef([]);
  const [stringDefaultFilter, setStringDefaultFilter] = useState('');
  const [resetGridTable, setResetGridTable] = useState(false);

  const nameView = "Order";

  const [isLoading, setLoading] = useState(true);
  const [rowsLoading, setRowsLoading] = useState(false);
  const [dataItem, setItem] = useState({ codeItem: 0, storeCode: 0, typeView: '', nameView: '' });
  const { allowWrite, allowView, userToken } = ValidView('Orders');
  const [stringFilter, setStringFilter] = useState(null);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [show_sc, setshow_sc] = useState(false);
  const handleClose_sc = () => setshow_sc(false);
  const [show_excel, setshow_excel] = useState(false);
  const handleClose_excel = () => setshow_excel(false);
  let [selectedRowsIds, setSelectedRowsIds] = useState([]);
  const [selectMultiRows, setSelectMultiRows] = useState([]);
  const [flagSelectAll, setFlagSelectAll] = useState(false);

  const selectUnselectAllRows = () => {
    setFlagSelectAll(true);
  };

  useEffect(() => {
    if (flagSelectAll) {
      setSelectMultiRows(selectedRowsIds);
      setFlagSelectAll(false);
    }
  }, [flagSelectAll, selectedRowsIds]);

  useEffect(() => {
    setStringFilter(null);
    setResetGridTable(!resetGridTable);
    objFilterRef.current = [];
    setStringDefaultFilter('');

    if (defaultFilter) {
      const { startFilter, stringDefaultFilter } = createDefaultFilter(defaultFilter);
      objFilterRef.current = startFilter;
      setStringDefaultFilter(stringDefaultFilter);
    }
  }, [defaultFilter]);

  useEffect(() => {
    if (allowView) {
      setColumnsGrid(setColumns({ modalDetail, allowWrite, changeDelay, setLoading, updateSelectMultiRows, selectUnselectAllRows }));
      setRowsLoading(true);
    }
  }, [allowView, allowWrite]);


  const modalDetail = (codeItem, storeCode, typeView) => {
    setShow(true);
    setItem({ codeItem, storeCode, typeView, nameView });
  };

  const modal_sc = (codeItem, typeView) => {
    setshow_sc(true);
  };

  const modal_excel = () => {
    setshow_excel(true);
  };

  const [columnsGrid, setColumnsGrid] = useState([]);
  let [page, setPage] = useState(1);
  let [pageSize, setPageSize] = useState(rowsPerPageArray[0]);

  const changeDelay = (textSearch, tableManager, column) => {
    const { searchApi } = tableManager;
    const { searchText, setSearchText } = searchApi;
    const setSearchAndFilter = (searchText, stringFilter) => {
      setSearchText(searchText);
      setStringFilter(stringFilter);
    };

    searchUtils(textSearch, setSearchAndFilter, column, searchText, objFilterRef.current);
  };

  const updateSelectMultiRows = (number) => {
    setSelectMultiRows(prevRows => {
      const index = prevRows.indexOf(number);
      if (index === -1) {
        return [...prevRows, number];
      } else {
        return prevRows.filter(item => item !== number);
      }
    });
  };

  function sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time)
    )
  }

  const onRowsRequest = async (requestData, tableManager) => {
    setLoading(true);

    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + userToken
      }
    };

    requestData.searchText = stringFilter ? requestData.searchText : stringDefaultFilter;
    const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + '/t1-comercios/orders?page=' + (page) + '&perPage=' + pageSize + requestData.searchText, requestOptions)
    .then((response) => {
      setLoading(false);
      return response.json();
    }).catch(console.warn);
    
  if (!response?.data) return;

    if (selectMultiRows.length > 0) {
      sleep(800).then(() => {
        setSelectedRowsIds(selectMultiRows);
      })
    }

    return {
      rows: response.data,
      totalRows: response.total_count,
      selectedRowsIds: selectMultiRows
    };
  };

  const OnPageChange = (event) => {
    setPage(event);
  }

  let dataSendClients = { 'typeView': 'Edit', 'codeItem': selectMultiRows, 'nameView': 'Send Orders' };
  const urlBaseExport = '/t1-comercios/orders/exportToExcel?page=1&perPage=99999'+stringDefaultFilter;

  return (
    <>
      <div className="tableWrapper">
        {!rowsLoading
          ? (<Spinner animation="border" role="status" variant="secondary" >
            <span className="visually-hidden">Loading...</span>
          </Spinner>) : (<>
            <GridTable
              key={resetGridTable}
              columns={columnsGrid}
              rowIdField={'fieldIdOrder'}
              onRowsRequest={onRowsRequest}
              isLoading={isLoading}
              pageSizes={rowsPerPageArray}
              pageSize={pageSize}
              onPageSizeChange={setPageSize}
              onPageChange={OnPageChange}
              selectedRowsIds={selectedRowsIds}
              onSelectedRowsChange={setSelectedRowsIds}
              showSearch={false}
              showColumnVisibilityManager={false}
              highlightSearch={false}
              minSearchChars={3}
              components={{ Header: (props) => <CustomHeader {...props} selectedRowsIds={selectMultiRows} allowWrite={allowWrite} modal_excel={modal_excel} modal_sc={modal_sc} setStringFilter={setStringFilter} /> }}
            />
          </>)}
      </div>
      <Modalv2 show={show} handleClose={handleClose} dataItem={dataItem} setRenderRows={[]} />
      <ModalMultiOrders show={show_sc} handleClose={handleClose_sc} dataItem={dataSendClients} setRenderRows={[]} />
      <ModalExportExcel show={show_excel} handleClose={handleClose_excel} objTextFind={stringFilter} urlBaseExport={urlBaseExport} nameFile={'Orders.xlsx'} />
    </>
  );
};

const createDefaultFilter = (defaultFilter) => {
  let startFilter = [];
  let stringDefaultFilter = '';
  if (defaultFilter && Object.keys(defaultFilter).length > 0) {
    for (const key in defaultFilter) {
      if (Object.hasOwnProperty.call(defaultFilter, key)) {
        startFilter[key] = defaultFilter[key];
        stringDefaultFilter += `&filterBy=${key}&filterValue=${defaultFilter[key]}`;
      }
    }
  }
  return { startFilter, stringDefaultFilter };
};

export default Orders;
